/* eslint-disable unicorn/filename-case */

/**
 * This dynamic route should match two different styles of URL:
 *
 * - `/tuote/red-bull-energiajuoma-0473l/9002490213886`
 * - `/tuote/9002490213886`
 */

export { getServerSideProps } from 'views/product/get-server-side-props'
export { ProductPage as default } from 'views/product/ProductPage'
